module.exports = __webpack_public_path__ + "96570e26d71fedde4ab5b6123ce2917a.png";


/*****************
 ** WEBPACK FOOTER
 ** ./src/system/assets/css/helpers/flags/flags16.png
 ** module id = 349
 ** module chunks = 0
 **/